import { render, staticRenderFns } from "./ArtikelEdit.vue?vue&type=template&id=3e7351aa&scoped=true"
import script from "./ArtikelEdit.vue?vue&type=script&lang=ts"
export * from "./ArtikelEdit.vue?vue&type=script&lang=ts"
import style0 from "./ArtikelEdit.vue?vue&type=style&index=0&id=3e7351aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7351aa",
  null
  
)

export default component.exports